import React from 'react';
import {renderToString} from 'react-dom/server';

import RankingTileNew from '@Themes/natucare/modules/Article/components/RankingTileNew/RankingTileNew';

import * as styles from '@/templates/Blog/templates/BlogPost/BlogPost.module.scss';

const replaceCollectionIDs = (items, match, id1, id2) => {
  let html = '';
  const id = id1 || id2;
  const products = items[id];

  if (!products || typeof products === 'undefined') {
    return html;
  }

  products.forEach(product => {
  const isHiddenProduct = product?.options?.indexOf('hide-product') > -1;

  const data = {
    label: product?.badge,
    heading: product?.productName,
    description: product?.description,
    picture: {
      src: product?.image,
      alt: product?.productName
    },
    buttons: product?.buttons ? product.buttons : [{
      href: null, label: null
    }],
    score: product.rating,
    scoreText: product.ratingLabel,
    accordion: product.accordions,
    classname: `${styles.rankingTile} rankingProductTitle`,
    id: isHiddenProduct ? 'alternative' : null,
    style: isHiddenProduct ? {display: 'none'} : null
  };
    html += renderToString(<RankingTileNew {...data} buttonHeading="ZOBACZ CENĘ" descriptionHeading="Szczegóły produktu" variant='v1' />);

  })



  // if (item?.variant === 'v1' || item?.variant === 'v2') {
    // html = renderToString(<RankingTileNew {...data} buttonHeading="ZOBACZ CENĘ" descriptionHeading="Szczegóły produktu" variant={item.variant} />);
  // } else {
    // html = renderToString(<RankingTile {...data} />);
    // html = renderToString(<RankingTileNew {...data} buttonHeading="ZOBACZ CENĘ" descriptionHeading="Szczegóły produktu" variant='v1' />);
  // }

  // Replace the matched string with the product type
  return html;
};

export default replaceCollectionIDs;
